import React, { useEffect, useState } from "react";
import { Button, Col, Row, Form, Modal } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";

import { showErrorDialog, showSuccessDialog } from "../../../utility";
import RemoveRedEye from "@material-ui/icons/RemoveRedEye";
import { changePassword, selectLoading } from "../../../pages/user/userSlice";
import Swal from "sweetalert2";
import { LayoutSplashScreen } from "../../../../_metronic/layout";

export const ResetPassword = (params) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const loading = useSelector(selectLoading);

  const [username, setUsername] = useState("");
  const [currentPassword, setCurrentPassword] = useState("");
  const [password, setPassword] = useState("");
  const [passwordAgain, setPasswordAgain] = useState("");

  // const dataParams = "";
  const dataParams =
    params?.location?.state === undefined
      ? ""
      : params?.location?.state?.params;

  const [passwordShown, setPasswordShown] = useState(false);
  const togglePasswordVisiblity = () => {
    setPasswordShown(passwordShown ? false : true);
  };
  const handleSave = async () => {
    // cek password
    if (password === passwordAgain) {
    } else {
      showErrorDialog("Password don't match");
      return;
    }

    const params = {
      user_id: dataParams?.user_id,
      current_password: currentPassword,
      new_password: password,
      new_password_confirmation: passwordAgain,
    };

    try {
      const response = await dispatch(changePassword(params));
      console.log(response, "response");
      if (response.payload.data.status_code === 200) {
        console.log("masuk if");

        await Swal.fire({
          title: "Success",
          html: `${response.payload.data.message}`,
          icon: "success",
          confirmButtonText: "OK",
          allowOutsideClick: () => {},
        });
        await history.goBack();
      } else {
        console.log("masuk else");

        Swal.fire({
          title: "Error!",
          html: `${response.payload.data.message}`,
          icon: "error",
          heightAuto: false,
          confirmButtonText: "Ok",
        }).then((result) => {});
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  return loading ? (
    <LayoutSplashScreen />
  ) : (
    <>
      <div className="login-form login-forgot" style={{ display: "block" }}>
        <div className="text-center mb-10 mb-lg-20">
          <h3 className="text-login-head text-white">Reset Password </h3>
        </div>
        <Form>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">Username</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control disabled type="text" value={dataParams.username} />
            </Col>
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">Current Password</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                required
                type={passwordShown ? "text" : "password"}
                onChange={(e) => setCurrentPassword(e.target.value)}
                value={currentPassword}
              />
            </Col>
            <span className="mt-3">
              <RemoveRedEye onClick={togglePasswordVisiblity} />
            </span>
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">New Password</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                required
                type={passwordShown ? "text" : "password"}
                onChange={(e) => setPassword(e.target.value)}
                value={password}
              />
            </Col>
            <span className="mt-3">
              <RemoveRedEye onClick={togglePasswordVisiblity} />
            </span>
          </Form.Group>
          <Form.Group as={Row} className="mb-3">
            <Form.Label column sm={3}>
              <b className="text-white">Re-Type Password</b>
            </Form.Label>
            <Col sm={8}>
              <Form.Control
                required
                type={passwordShown ? "text" : "password"}
                onChange={(e) => setPasswordAgain(e.target.value)}
                value={passwordAgain}
              />
            </Col>
          </Form.Group>
        </Form>

        <div className="form-group d-flex flex-wrap flex-center">
          <Link to="/auth">
            <Button
              type="button"
              id="kt_login_forgot_cancel"
              className="btn btn-outline-white font-weight-bold px-9 py-4 my-3 mx-4"
            >
              Cancel
            </Button>
          </Link>
          <Button
            className="btn btn-white font-weight-bold px-9 py-4 my-3 mx-4"
            onClick={handleSave}
          >
            Submit
          </Button>
        </div>
      </div>

      {/*  Modal */}
    </>
  );
};
